import { SxStyle } from '../../types/style';

// const contentBox: SxStyle = {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center'
// };

const contentBoxTextField: SxStyle = {
    // width: '560px',
    width: '100%',
    marginRight: '16px'
};

export const filterStyle = {
    // contentBox,
    contentBoxTextField
};